import { useWhitelabelConfig } from '@mm/hooks/src/use-whitelabel-config';
import classnames from 'classnames';
import React from 'react';
import styles from './Switch.module.css';

type Props = {
  css?: { container?: string; thumb?: string; label?: string };
  checked: boolean;
  onChange?: (checked: boolean) => void;
  disabled?: boolean;
  label?: string; // default: ON and OFF depending on checked state
  thumb?: string; // Text on the thumb circle
  theme?: 'default' | 'instachamp';
  hideLabel?: boolean;
};

export const Switch = ({
  label = '',
  thumb = '',
  disabled,
  css,
  checked,
  onChange,
  theme,
  hideLabel,
}: Props) => {
  const classList = classnames(css?.container, styles.container, {
    [styles.disabled]: disabled,
    [styles.checked]: checked,
    [styles[`containerTheme__${theme}`]]: theme,
  });

  const defaultLabel = checked ? 'ON' : 'OFF';
  const { primaryButtonStyle, isWhitelabelCompany } = useWhitelabelConfig();
  const whitelabelStyle =
    isWhitelabelCompany && checked ? primaryButtonStyle : {};

  return (
    <label className={classList} style={whitelabelStyle}>
      <input
        type="checkbox"
        className={styles.checkbox}
        disabled={disabled}
        checked={checked}
        onChange={e => onChange?.(e.target.checked)}
      />
      <span className={classnames(styles.thumb, css?.thumb)}>{thumb}</span>
      {!hideLabel && (
        <span className={classnames(styles.label, css?.label)}>
          {label || defaultLabel}
        </span>
      )}
    </label>
  );
};
